<template>
  <v-container>
    <h2>Сонгон xичээлийн онлайн өрөөнүүд</h2>
    <v-container class="mx-auto" style="width: 80%"> </v-container>
    <v-container
      color="transparent"
      :elevation="0"
      v-for="(school, index) in schools"
      :key="index"
    >
      <v-card-title class="m-0">
        <div class="d-flex justify-content-end">
          <label v-if="canChange">
            <input
              type="checkbox"
              style="transform: scale(1.4)"
              class="mr-2"
              v-model="removeRoom"
            />
            <span class="" style="font-weight: bold; font-size: 14pt"
              >Өрөө арилгаx</span
            >
          </label>
        </div>
      </v-card-title>

      <v-card-text>
        <template v-if="roomList.length > 0">
          <v-container
            v-for="(room, index) in roomList"
            v-bind:key="room.id"
            class="mb-4"
          >
            <v-row justify="start">
              <div>
                {{ index + 1 }}.
                <span style="color: black; font-weight: bold">{{
                  room.name
                }}</span>
                <span class="color:grey"> ({{ room.teachers.length }})</span>
              </div>
              <v-icon
                color="primary"
                class="ml-4"
                v-if="canChange"
                @click="_addTeacher(school, room)"
              >
                mdi-account-multiple-plus-outline
              </v-icon>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-card
                flat
                v-for="(teacher, index) in room.teachers"
                v-bind:key="index"
                @click="_clicked(school, room, teacher)"
                :title="teacher.onlineroom"
                class="ma-2"
                style="
                  max-width: 100%;
                  box-shadow: rgba(47, 60, 74, 0.01) 0px 8px 32px,
                    rgba(47, 60, 74, 0.02) 0px 8px 16px;
                "
                width="240"
              >
                <v-card-text>
                  <div class="d-flex align-center">
                    <v-btn
                      class="mx-2"
                      fab
                      :elevation="0"
                      small
                      color="grey lighten-3"
                    >
                      <v-icon dark> mdi-account </v-icon>
                    </v-btn>
                    <span v-if="teacher.onlineroom == null" class="text-danger"
                      >no room</span
                    >
                    <span v-else>
                      <span class="text-primary" style="width: 100%">{{
                        getXNameWithLastName(
                          teacher.firstName,
                          teacher.lastName
                        )
                      }}</span>
                    </span>
                  </div>
                </v-card-text>
              </v-card>
            </v-row>
          </v-container>
        </template>
        <div v-else class="alert alert-info text-center">
          Одоогоор мэдээлэл ороогүй байна.
        </div>
      </v-card-text>
    </v-container>
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Багш нэмэх</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p v-if="currentSelectedLessonCat">
              <span class="font-weight-bold">Xичээл: </span>
              {{ currentSelectedLessonCat.name }}
            </p>
            <form class="user">
              <div class="row">
                <div class="col" v-if="teachers && teachers.length > 0">
                  <div class="form-group">
                    <label for="exampleFormControlSelect1"
                      >Хичээл заах багш:</label
                    >
                    <select class="form-control" v-model="selectedTeacher">
                      <option
                        v-for="(teacher, index) in teachers"
                        v-bind:value="teacher"
                        :key="index"
                      >
                        {{ index + 1 }}. {{ teacher.name }} -
                        {{ teacher.email }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Хаах
            </button>
            <button
              v-if="selectedTeacher"
              @click="_saveTeacher()"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >
              Нэмэх
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </v-container>
</template>

<script>
const fb = require("../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig.js";
import moment from "moment";
import myfunction from "@/components/global/myfunction.js";

export default {
  name: "XSongonOnlineRooms",
  data() {
    return {
      removeRoom: false,
      canChange: false,
      addRoom: false,
      schools: [],
      defaultPrograms: ["А", "Б", "В", "Г", "Д", "Е", "Ё"],
      userObject: null,
      selectedProgram: { onlineroom: null },
      selectedDepartment: null,
      selectedSchool: null,

      lessonList: [],
      teachers: [],
      selectedTeacher: null,
      currentSelectedLessonCat: null,

      roomList: [],
      currentSelectedSchool: null,
      loading:false
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
    ll() {
      return this.roomList.length;
    },
  },
  mixins: [myfunction],
  created() {
    this._initialize();
  },
  methods: {
    async _readRooms(school) {
      if (school) {
        var query = fb.db
          .collection("schools")
          .doc(school.id)
          .collection("songononlinerooms")
          .orderBy("name", "asc");
        query.onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            school.rooms = [];
            this.roomList = [];
            querySnapshot.forEach((lessonDoc) => {
              let group = lessonDoc.data();
              group.id = lessonDoc.id;

              if (group.teachers == undefined) group.teachers = [];
              this.roomList.push(group);
            });
          }
        });
      }
    },
    _addTeacher(school, room) {
      // this.school=null;
      this.selectedTeacher = null;
      this.currentSelectedLessonCat = room;
      this.currentSelectedSchool = school;
      $("#exampleModal").modal("toggle");
    },
    _saveTeacher() {
 
      if (
        this.selectedTeacher != null &&
        this.selectedTeacher.onlineroom != undefined
      ) {
        var path =
          "schools/" +
          this.currentSelectedSchool.id +
          "/songononlinerooms/" +
          this.currentSelectedLessonCat.id;
 
        if(this.selectedTeacher.lastName==undefined || this.selectedTeacher.lastName==null)
          this.selectedTeacher.lastName = this.selectedTeacher.lastname
  
        fb.db
          .doc(path)
          .update({
            teachers: fb.firestore.FieldValue.arrayUnion({
              firstName: this.selectedTeacher.name,
              lastName: this.selectedTeacher.lastName,
              onlineroom: this.selectedTeacher.onlineroom,
              ref: this.selectedTeacher.ref,
            }),
          })
          .then(() => {
            console.log("Document successfully written!");
          })
          .catch((error) => {
            console.error("dsfssdfsdfsdfasd sdfasdfsdfsdfsadf");
          });

        $("#exampleModal").modal("hide");
      } else {
        $("#exampleModal").modal("hide");
        confirm(
          this.selectedTeacher.firstName + " багшид онлайн өрөө байxгүй байна!"
        );
      }
      this.selectedTeacher = null;
      this.currentSelectedLessonCat = null;
      this.currentSelectedSchool = null;
    },
    _clicked(school, room, teacher) {
      var path = "schools/" + school.id + "/songononlinerooms/" + room.id;
      console.log(path)
      if (this.removeRoom) {
        var yes = confirm(teacher.firstName + " багшийн өрөөг арилгаx уу?");
        if (yes) {
          fb.db
            .doc(path)
            .update({
              teachers: fb.firestore.FieldValue.arrayRemove({
                firstName: teacher.firstName,
                onlineroom: teacher.onlineroom,
                ref: teacher.ref,
              }),
            })
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        }
      } else window.open(teacher.onlineroom, "_blank");
    },
    async _readAllTeacher(school) {
      fb.db
        .collection("schools/" + school.id + "/teachers")
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let teacher = doc.data();
            teacher.ref = doc.ref;
            teacher.id = doc.id;
            this.teachers.push(teacher);
          });
        });
    },
    async _checkLessonCategories(school) {
      this.loading = true;
      var query;
      query = fb.db
        .collection("schools/" + school.id + "/categories")
        .orderBy("index", "asc");
      if (query != null) {
        var documentSnapshots = await query.get();
        documentSnapshots.forEach(async (doc) => {
          let object = doc.data();
          object.id = doc.id;
          if (object.typeDetail && object.typeDetail.id == "songoh") {
            object.teachers = [];

            var xx = await fb.db
              .collection("schools/" + school.id + "/songononlinerooms/")
              .doc(object.id)
              .get();

            if (!xx.exists) {
              console.log("creating.....");
              await fb.db
                .collection("schools/" + school.id + "/songononlinerooms/")
                .doc(object.id)
                .set({
                  name: object.name,
                  createdAt: new Date(),
                });
            }
            this.lessonList.push(object);
          }
        });
      }
      //await this._readAllTeacher(school);
      this.loading = false;
    },
    async _getLessonsOfTeacher(school, teacher) {
      teacher.lessons = [];
      var query;
      query = fb.db
        .collection("schools/" + school.id + "/lessons")
        .where("teacher", "==", teacher);

      if (query != null) {
        var lessonsDatas = await query.get();
        for (const doc of lessonsDatas.docs) {
          let lesson = doc.data();
          lesson.id = doc.id;
          console.log(lesson.id, lesson.deleted);
          teacher.lessons.push(lesson);
          // if(lesson.category && lesson.category.id){
          //     await this._findCategory(school.id,lesson);
          //     if(!(lesson.deleted!=null&&lesson.deleted!=undefined&&lesson.deleted==true)){
          //       school.lessons.push(lesson);
          //     }
          // }
        }
      }
      this.loading = false;
    },
    async _readTeacherData(school, roomData) {
      roomData.lessons = [];
      fb.db
        .doc(roomData.teacher.path)
        .get()
        .then(async (teacherDoc) => {
          let teacherData = teacherDoc.data();
          // teacherData.id = teacherDoc.id;
          // teacherData.ref= teacherDoc.ref;
          // teacher.firstName = teacherData.firstName;
          // teacher.lastName = teacherData.lastName;
          // teacher.onlineRoom = teacherData.onlineroom;
          await this._getLessonsOfTeacher(school, roomData.teacher);
          school.songononlinerooms.push({ name: "xaa", teacher: teacherData });
        });
    },
    async _readTeachers(school) {
      school.songononlinerooms = [];
      fb.db
        .collection("schools/" + school.id + "/songononlinerooms/")
        .orderBy("name", "asc")
        .get()
        .then((songononlinerooms) => {
          songononlinerooms.forEach(async (room) => {
            let roomData = room.data();
            roomData.id = room.id;
            roomData.ref = room.ref;
            await this._readTeacherData(school, roomData);
          });
        });
    },
    async _initialize() {
      this.loading = true
      if (
        this.userProfile.role == "sts" ||
        this.userProfile.role == "admin" ||
        this.userProfile.role == "manager"
      ) {
        this.canChange = true;
      } else this.canChange = false;

      this.schools = [];
      var cusDoc = await this.userProfile["customer"].get();
      if (
        this.userProfile.role != undefined &&
        this.userProfile.role != null &&
        this.userProfile.role != "" &&
        (this.userProfile.role == "admin" )
      ) {
        var schools = await cusDoc.data().schools;
        for (var school of schools) {
          var schoolDoc = await school.get();
          let school = schoolDoc.data();
          school.id = schoolDoc.id;
          school.ref = schoolDoc.ref;
          await this._checkLessonCategories(school);
          await this._readRooms(school);
          await this._readAllTeacher(school);
          this.schools.push(school);
        }
      } else if (
        this.userProfile.role &&
        this.userProfile.role != "" &&
        (this.userProfile.role == "teacher" ||
          this.userProfile.role == "manager" || this.userProfile.role == "sts")
      ) {
        schoolDoc = await cusDoc.data().school.get();
        let school = schoolDoc.data();
        school.id = schoolDoc.id;
        school.ref = schoolDoc.ref;
        //await this._checkLessonCategories(school);
        await this._readRooms(school);
        await this._readAllTeacher(school);
        this.schools.push(school);
      }
      this.loading = false
    },
  },
};
</script>